import { render } from "./RakutenHomeFirst.vue?vue&type=template&id=2ba591f5"
import script from "./RakutenHomeFirst.vue?vue&type=script&lang=js"
export * from "./RakutenHomeFirst.vue?vue&type=script&lang=js"

import "./RakutenHomeFirst.vue?vue&type=style&index=0&id=2ba591f5&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__